import React from "react"
import { useHistory } from "react-router-dom"
import styled from "styled-components"
import devices from "styles/devices"
import { Button, ButtonType } from "components/atoms/Button"
import Typography from "components/_blueprint/Typography/Typography"

interface SpeedUpApplicationCardProps {
  friendlyId: string
}

const SpeedUpCard = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 24px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media screen and ${devices.bp_sm} {
    flex-direction: row;
    gap: 32px;
  }
`

const NextStepBadge = styled.div`
  background: ${({ theme }) => theme.colors.status.warning};
  border-radius: 8px;
  padding: 8px 12px;
  width: fit-content;
  margin-bottom: 16px;

  span {
    font-weight: 600;
    font-size: 14px;
    line-height: 1.8;
    color: ${({ theme }) => theme.colors.text.primary};
    white-space: nowrap;
  }
`

const DocumentsDetails = styled.div`
  display: flex;
  flex-direction: column;
`

const DocumentsDetailsButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
`

const CallDetails = styled.div`
  border-radius: 32px;
  padding: 24px;
  background: ${({ theme }) => theme.colors.background.tertiary};
  @media screen and ${devices.bp_sm} {
    width: 600px;
  }
`

const BenefitsList = styled.ul`
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  li {
    font-weight: 500;
    font-size: 16px;
    line-height: 1.8;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`

const StyledLargeBody = styled(Typography.LargeBody)`
  font-weight: 600;
  margin: 0 0 16px 0;
`

export const SpeedUpApplicationCard: React.FC<SpeedUpApplicationCardProps> = ({ friendlyId }) => {
  const history = useHistory()

  const handleViewDocuments = () => {
    history.push(`/application/${friendlyId}/documents`)
  }

  return (
    <SpeedUpCard>
      <DocumentsDetails>
        <NextStepBadge>
          <span>Next step</span>
        </NextStepBadge>

        <Typography.H4 margin="8px 0">Speed up your application</Typography.H4>
        <Typography.Body color="secondary" margin="0">
          Your expert may have asked for some documents. You can view the list and upload them
          securely here before your call to get things moving quicker.
        </Typography.Body>

        <DocumentsDetailsButtonWrapper>
          <Button
            type={ButtonType.Solid}
            text="View & upload documents"
            onClick={handleViewDocuments}
          />
        </DocumentsDetailsButtonWrapper>
      </DocumentsDetails>
      <CallDetails>
        <StyledLargeBody>What you'll get from this call</StyledLargeBody>
        <BenefitsList>
          <li>Choose the best mortgage product for you</li>
          <li>Begin your application with your expert</li>
          <li>Get one step closer to getting the keys</li>
        </BenefitsList>
      </CallDetails>
    </SpeedUpCard>
  )
}
